// ========================================
// Responsive Swiper initializer (ported from "The Inside 3.0" sprint)
// Drives any `.swiper[data-swiper]` element using data-* attributes:
//   data-desktop / data-laptop / data-tablet / data-mobile = slides per view
//   data-slider-from = string (e.g. 650 / 992) — only enable below this width
//   data-space / data-speed / data-delay = numbers
//   data-loop / data-autoplay / data-navigation / data-pagination = booleans
// Requires the global Swiper library (assets/swiper.min.js).
// ========================================

function initResponsiveSwiperTi26(slider) {
  if (!slider) return;

  const sliderFrom = parseInt(slider.dataset.sliderFrom) || null;
  const autoplay = slider.dataset.autoplay === "true";
  const delay = parseInt(slider.dataset.delay) || 0;
  const loop = slider.dataset.loop === "true";
  const speed = parseInt(slider.dataset.speed) || 400;
  const space = parseInt(slider.dataset.space) || 20;
  const desktop = parseFloat(slider.dataset.desktop) || 4;
  const laptop = parseFloat(slider.dataset.laptop) || 3;
  const tablet = parseFloat(slider.dataset.tablet) || 2;
  const mobile = parseFloat(slider.dataset.mobile) || 1;
  const navigation = slider.dataset.navigation === "true";
  const pagination = slider.dataset.pagination === "true";

  // Optional pc-nav style: dots_only | centered | full_width | counter | scrollbar.
  // When present it overrides the data-navigation / data-pagination booleans.
  const navStyle = slider.dataset.navStyle || null;
  let useNav = navigation;
  let usePagination = pagination;
  let paginationType = "bullets";
  let paginationClickable = true;
  let useScrollbar = false;
  if (navStyle) {
    useNav = navStyle === "centered" || navStyle === "full_width" || navStyle === "counter";
    usePagination = navStyle !== "scrollbar";
    paginationClickable = navStyle !== "counter";
    paginationType = navStyle === "counter" ? "fraction" : "bullets";
    useScrollbar = navStyle === "scrollbar";
  }

  // Look inside the swiper first; fall back to a sibling .custom-arrow in the parent
  // (used when the arrow markup is placed outside the swiper element to avoid CSS mask clipping)
  const parentArrow = slider.parentElement && slider.parentElement.querySelector(':scope > .custom-arrow');
  const nextBtn = slider.querySelector(".swiper-button-next") ||
                  (parentArrow ? parentArrow.querySelector(".swiper-button-next") : null);
  const prevBtn = slider.querySelector(".swiper-button-prev") ||
                  (parentArrow ? parentArrow.querySelector(".swiper-button-prev") : null);
  const paginationEl = slider.querySelector(".swiper-pagination");
  const arrowWrapper = slider.querySelector(".custom-arrow");

  const shouldEnableSlider = !sliderFrom || window.innerWidth < sliderFrom;

  if (slider.swiper) {
    slider.swiper.destroy(true, true);
  }

  if (shouldEnableSlider) {
    const totalSlides = slider.querySelectorAll(".swiper-slide").length;
    const currentSlidesPerView =
      window.innerWidth >= 1200 ? desktop :
      window.innerWidth >= 992 ? laptop :
      window.innerWidth >= 650 ? tablet :
      mobile;

    const enableLoop = loop && totalSlides > currentSlidesPerView;

    const progressFill = slider.querySelector(".pc-progress-fill");

    new Swiper(slider, {
      loop: enableLoop,
      speed: speed,
      spaceBetween: space,
      slidesPerView: mobile,
      grabCursor: true,
      simulateTouch: true,
      breakpoints: {
        650: { slidesPerView: tablet },
        992: { slidesPerView: laptop },
        1200: { slidesPerView: desktop }
      },
      autoplay: autoplay
        ? {
            delay: delay,
            disableOnInteraction: false
          }
        : false,
      navigation: useNav && nextBtn && prevBtn
        ? {
            nextEl: nextBtn,
            prevEl: prevBtn
          }
        : false,
      pagination: usePagination && paginationEl
        ? {
            el: paginationEl,
            clickable: paginationClickable,
            type: paginationType
          }
        : false,
      on: {
        slideChange: function (s) {
          if (useScrollbar && progressFill) {
            progressFill.style.width = ((s.realIndex + 1) / s.slides.length * 100) + "%";
          }
        }
      },
      observer: true,
      observeParents: true,
      watchOverflow: true
    });

    if (useScrollbar && progressFill && slider.swiper && slider.swiper.slides.length > 0) {
      progressFill.style.width = (1 / slider.swiper.slides.length * 100) + "%";
    }

    if (useNav) {
      if (arrowWrapper) arrowWrapper.style.display = "";
      if (nextBtn) {
        nextBtn.style.display = "";
        nextBtn.style.pointerEvents = "";
        nextBtn.style.opacity = "";
        nextBtn.removeAttribute("disabled");
      }
      if (prevBtn) {
        prevBtn.style.display = "";
        prevBtn.style.pointerEvents = "";
        prevBtn.style.opacity = "";
        prevBtn.removeAttribute("disabled");
      }
    }

    if (paginationEl) {
      paginationEl.style.display = "";
    }
  } else {
    if (useNav) {
      if (arrowWrapper) arrowWrapper.style.display = "none";

      if (nextBtn) {
        nextBtn.setAttribute("disabled", "disabled");
        nextBtn.style.pointerEvents = "none";
        nextBtn.style.opacity = "0.4";
        nextBtn.style.display = "none";
      }

      if (prevBtn) {
        prevBtn.setAttribute("disabled", "disabled");
        prevBtn.style.pointerEvents = "none";
        prevBtn.style.opacity = "0.4";
        prevBtn.style.display = "none";
      }
    }

    if (paginationEl) {
      paginationEl.style.display = "none";
    }
  }
}

function handleResponsiveSwipersTi26(container = document) {
  container.querySelectorAll(".swiper[data-swiper]").forEach(function (slider) {
    initResponsiveSwiperTi26(slider);
  });
}

// Initial page load
document.addEventListener("DOMContentLoaded", function () {
  handleResponsiveSwipersTi26();

  // Watch async-loaded sections like product recommendations
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (node.matches(".swiper[data-swiper]")) {
          initResponsiveSwiperTi26(node);
        } else if (node.querySelector && node.querySelector(".swiper[data-swiper]")) {
          handleResponsiveSwipersTi26(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Resize debounce
let swiperResizeTimerTi26;
window.addEventListener("resize", function () {
  clearTimeout(swiperResizeTimerTi26);
  swiperResizeTimerTi26 = setTimeout(function () {
    handleResponsiveSwipersTi26();
  }, 150);
});

// Shopify Theme Editor support
document.addEventListener("shopify:section:load", function (event) {
  handleResponsiveSwipersTi26(event.target);
});

document.addEventListener("shopify:section:reorder", function (event) {
  handleResponsiveSwipersTi26(event.target);
});

document.addEventListener("shopify:block:select", function (event) {
  const section = event.target.closest(".shopify-section");
  if (section) {
    handleResponsiveSwipersTi26(section);
  }
});
